import { gql } from "@apollo/client";
import USER_SUMMARY_FRAGMENT from "../../../queries/fragments/userSummaryFragment";

export const USER_FRAGMENT = gql`
  fragment User on User {
    id
    createdAt
    registeredAt
    firstName
    lastName
    name @client
    logo @client
    occupationId
    roleId
    usage
    updatedAt
    email
    appLanguage
    transcriptionLanguage
    permissions
    removedPermissions
    pinnedTaskIds
    products
    showAddresses
    licenseType
    licenseTrial
    exportSettings {
      showLeftColumn
      showCreatedAt
      showCreatedBy
      showUpdated
      showGeneratedBy
      showTaskHeader
      showNullFields
      imageSize
      splitAccountingExcel
    }
    verified
    freeTasks
    company {
      id
      name
      currency
      license {
        status
        expiresAt
        products {
          id
          quantity
        }
      }
      createdBy {
        ...UserSummary
      }
      currentMember {
        roles
      }
      members(perPage: 100) {
        results {
          user {
            id
            firstName
            lastName
            email
          }
          roles
        }
      }
      stages {
        id
        name
        color
        automation
        companyWide
      }
      settings {
        tasks {
          requireTaskTypeOnCreate
        }
        auth {
          inactivityMinutes
          inactivityAlert
        }
        ai {
          disabled
        }
      }
    }
    companySize
    affiliationId
    affiliationCode
    showItemsLabels
    pendings {
      groups
    }
  }
  ${USER_SUMMARY_FRAGMENT}
`;
